import script from "./SaveToBoardModal.vue?vue&type=script&setup=true&lang=js"
export * from "./SaveToBoardModal.vue?vue&type=script&setup=true&lang=js"

import "./SaveToBoardModal.vue?vue&type=style&index=0&id=50d32743&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-50d32743"]])

export default __exports__